if (!customElements.get('bra-calc-form')) {
  class BraCalcForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('input');
      this.submit = this.form.querySelector('button[type="submit"]');
      this.errors = this.form.querySelector('.errors');

      this.inputs.forEach((input) => {
        switch (input.getAttribute('name')) {
          case 'chest':
            this.chest_input = input
            break;
          case 'bust':
            this.bust_input = input
            break;
          case 'below':
            this.below_input = input
            break;
        }
      });

      if(!this.chest_input || !this.bust_input || !this.below_input) {
        const load_error = document.createElement('p');
        load_error.innerHTML = 'There was a problem loading the bra fit calculator. Please try again later.'
        this.form.after(load_error);
        this.form.remove();
      }
      else {
        this.addListeners();
      }
    }

    addListeners() {
      this.submitHandler = this.braCalc.bind(this)
      this.keyupHandler = this.validate.bind(this);

      this.form.addEventListener('submit', this.submitHandler);
      this.inputs.forEach((el) => {
        el.addEventListener('keyup', this.validate(evt.target).bind(this));
      });
    }

    braCalc(evt) {
      evt.preventDefault();

      let has_input_errors = false;
      this.inputs.forEach((input) => {
        let input_valid = this.validate(input);
        if(!input_valid){
          has_input_errors = true;
        }
      });

      if(has_input_errors){
        var error_message = "You have some invalid measurements. All measurements must be in inches. Please recheck your measurements.";
      }
      else {
        var cup = "";
        var cupLabel = "";
        var error = 0;
        var n2 = 0;
        var success_message = "";
        var error_message = "";
        /*  this.form.size.value = "";*/
        var chest = Math.ceil(this.chest_input.value);
        if (chest % 2 == 1) chest++;
        if (!this.chest_input.value || !this.bust_input.value || !this.below_input.value) {
            error = 1;
            error_message = "Please fill in all fields.";
        } else if (this.chest_input.value < 30 || this.chest_input.value > 46 || this.below_input.value < 24) {
            error = 1;
            error_message = "We're sorry, but your measurements fall outside our calculatable range.";
        } else {
            n2 = Math.floor(this.bust_input.value - this.below_input.value);
            if (n2 <= 0) {
                error = 1;
                error_message = "Measurement 2 must be greater than measurement 3. Please recheck your measurements.";
            } else {
                switch (n2) {
                    case 1:
                        cup = "AA";
                        cupLabel = cup;
                        break;
                    case 2:
                        cup = "A";
                        cupLabel = cup;
                        break;
                    case 3:
                        cup = "B";
                        cupLabel = cup;
                        break;
                    case 4:
                        cup = "C";
                        cupLabel = cup;
                        break;
                    case 5:
                        cup = "D";
                        cupLabel = cup;
                        break;
                    case 6:
                        cup = "DD";
                        cupLabel = cup;
                        break;
                    case 7:
                        cup = "DDD";
                        cupLabel = cup;
                        break;
                    case 8:
                        cup = "E";
                        cupLabel = "F (4D)";
                        break;
                    case 9:
                        cup = "F";
                        cupLabel = "G (5D)";
                        break;
                    case 10:
                        cup = "DD%2B";
                        cupLabel = "H (6D)";
                        break;
                    case 11:
                        cup = "DD%2B";
                        cupLabel = "I (7D)";
                        break;
                    case 12:
                        cup = "DD%2B";
                        cupLabel = "J (8D)";
                        break;
                    case 13:
                        cup = "DD%2B";
                        cupLabel = "K (9D)";
                        break;
                    case 14:
                        cup = "DD%2B";
                        cupLabel = "L (10D)";
                        break;
                    case 15:
                        cup = "DD%2B";
                        cupLabel = "M (11D)";
                        break;
                    default:
                        error = 1;
                        error_message = "We're sorry, but your measurements fall outside our calculatable range.";
                        break;
                }
            }
        }
        if (!error && n2 < 9) {
            error_message = "";
            /*this.form.size.value = chest+cup;*/
            //if (cup == "AA") cup = "A";
            success_message = "Your Size is " + chest + "" + cupLabel +
                ". &nbsp;<a href=\"/collections/womens-sports-bras?filter.v.option.band=" +
                chest + "&filter.v.option.cup=" + cup + "&sort_by=manual\">Shop " + chest + "" + cupLabel +
                " Bras</a>";

        } else if (!error) {
            /*this.form.size.value="";*/
            success_message = "Your Size is " + chest + "" + cupLabel + " ";
            error_message =
                "While we unfortunately do not currently carry that size, our Bravangelists are happy to help you locate some options in your size. Give us a call at 800-342-4448";
        }
      }

      this.removeFormError();

      if(error_message){
        const error_message_element = document.createElement('li');
        error_message_element.innerHTML = error_message;
        this.setFormError(`<li>${error_message}</li>`);
      }

      if(success_message){
        this.setSuccess(success_message);
      }
    }

    validate(input) {
      this.removeInputError(input);
      if(isNaN(parseFloat(input.value)) || !isFinite(input.value)){
        this.setInputError(input);
        return false;
      }
      return true;
    }

    setSuccess(success_message) {
      this.removeSuccess(success_message);

      const success_message_element = document.createElement('p');
      success_message_element.classList.add('success');
      success_message_element.innerHTML = success_message;
      this.form.after(success_message_element);
    }

    removeSuccess() {
      if(this.querySelector('.success')){
        this.querySelector('.success').remove();
      }
    }

    setFormError(error_list) {
      this.errors.querySelector('.js-errors-text').innerHTML = `<ul class="styled-list">${error_list}</ul>`;
      this.errors.hidden = false;
    }

    removeFormError() {
      this.errors.querySelector('.js-errors-text').innerHTML = '';
      this.errors.hidden = true;
    }

    setInputError(input) {
      input.setAttribute('autofocus','');
      input.setAttribute('aria-invalid','true');
      input.setAttribute('aria-describedby',`${input.getAttribute('name')}-error`);
    }

    removeInputError(input) {
      input.removeAttribute('autofocus','');
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    }
  }

  customElements.define('bra-calc-form', BraCalcForm);
}
